"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../User/UserName"));

var _TopicComments = _interopRequireDefault(require("../topic-list-view/TopicComments"));

var _TopicLastPost = _interopRequireDefault(require("../topic-list-view/TopicLastPost"));

var _htmlParser = _interopRequireDefault(require("../utils/htmlParser"));

var _IdeationStatus = _interopRequireDefault(require("../topic-list-view/IdeationStatus"));

var _common = require("@insided/shared/utils/common");

var _urlGenerator = require("../utils/urlGenerator");

var _TopicContainer = _interopRequireDefault(require("@insided/destination/modules/Content/TopicList/TopicContainer"));

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _TopicMetadata = require("@insided/destination/modules/Content/TopicList/TopicMetadata");

var _contentType = require("@insided/shared/utils/contentType");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IdeaView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeaView, _Component);

  var _super = _createSuper(IdeaView);

  function IdeaView() {
    var _this;

    (0, _classCallCheck2.default)(this, IdeaView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      votes: _this.props.votes,
      currentUserVoted: _this.props.likedOrVotedByCurrentUser
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleVoteStatus", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var event;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.props.isGuest) {
                _context.next = 4;
                break;
              }

              event = new CustomEvent('GuestUserAction');
              window.dispatchEvent(event);
              return _context.abrupt("return");

            case 4:
              if (!_this.state.currentUserVoted) {
                _context.next = 10;
                break;
              }

              _this.setState(function (state) {
                return {
                  currentUserVoted: false,
                  votes: state.votes - 1
                };
              });

              _context.next = 8;
              return _axios.default.post("/community/api/ideas/".concat(_this.props.id, "/unvote"));

            case 8:
              _context.next = 13;
              break;

            case 10:
              _this.setState(function (state) {
                return {
                  currentUserVoted: true,
                  votes: state.votes + 1
                };
              });

              _context.next = 13;
              return _axios.default.post("/community/api/ideas/".concat(_this.props.id, "/vote"));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return _this;
  }

  (0, _createClass2.default)(IdeaView, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (previousProps.votes !== this.props.votes) {
        this.setState({
          votes: this.props.votes
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _authorData$author$id;

      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          content = _this$props.content,
          replyCount = _this$props.replyCount,
          lastActivityAt = _this$props.lastActivityAt,
          lastContributor = _this$props.lastContributor,
          author = _this$props.author,
          ideaStatus = _this$props.ideaStatus,
          lastPostId = _this$props.lastPostId,
          authorData = _this$props.authorData,
          categoryName = _this$props.categoryName,
          categoryUrl = _this$props.categoryUrl,
          publicTopicUrl = _this$props.topicUrl.destination;
      var _this$state = this.state,
          votes = _this$state.votes,
          currentUserVoted = _this$state.currentUserVoted;

      var strippedContent = _htmlParser.default.stripHtml(content);

      var lastPostUrl = (0, _urlGenerator.getLastPostUrl)(publicTopicUrl, lastPostId);

      var relativeDate = _common.common.relativeDate(lastActivityAt);

      var topicCategoryMetadataPhrase = (0, _TopicMetadata.getMetadataPhrase)(_contentType.CONTENT_TYPE_IDEA);

      var resolveUser = function resolveUser(person) {
        var freshData = person !== null && person !== void 0 && person.id && authorData ? authorData[person.id] : null;
        return freshData ? _objectSpread(_objectSpread({}, freshData), {}, {
          reputation: person.reputation
        }) : _objectSpread(_objectSpread({}, person), {}, {
          name: person.username
        });
      };

      var user = resolveUser(author);
      var lastContributorUser = resolveUser(lastContributor);
      var userTitle = (author === null || author === void 0 ? void 0 : author.id) && (authorData === null || authorData === void 0 ? void 0 : (_authorData$author$id = authorData[author.id]) === null || _authorData$author$id === void 0 ? void 0 : _authorData$author$id.userTitle);
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('topic-view', 'topic-view--ideation', 'idea-view', 'topic-view--unread')
      }, (0, _preact.h)("div", {
        className: "topic-view_header"
      }, (0, _preact.h)("div", {
        className: "topic-view_header-item"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: user,
        extraClass: "avatar",
        showRank: true
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('topic-view_header-items-gathered', {
          'topic-view_header-items_without-category': !_common.common.isModuleActive('categoriesV2IdeasAndPU') || !categoryName
        })
      }, (0, _preact.h)("div", {
        className: "topic-view_header-item"
      }, (0, _preact.h)(_UserName.default, {
        user: user,
        extraClass: "username"
      }), userTitle && (0, _preact.h)("span", {
        className: "user-title text--meta"
      }, userTitle)), _common.common.isModuleActive('categoriesV2IdeasAndPU') && !!categoryName && (0, _preact.h)("div", {
        className: (0, _classnames.default)('topic-view_header-item', 'text--meta', 'category-meta')
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(categoryUrl),
        "data-track-type": "click",
        className: "topic-list-item-card_topic-location-link text--meta"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, (0, _preact.h)(_phrase.default, {
        p: topicCategoryMetadataPhrase
      })), "\xA0", (0, _preact.h)("span", {
        className: "topic-view_header-item_category-link"
      }, categoryName))))), (0, _preact.h)(_TopicContainer.default, {
        anchorProps: {
          href: publicTopicUrl,
          className: 'qa-topic-title'
        },
        topicInfoWrapperClassName: (0, _classnames.default)('topic-view_info', 'idea-view_info', 'add_margin')
      }, (0, _preact.h)("h4", {
        className: "thread-list-block__title"
      }, (0, _preact.h)("span", {
        className: "thread-list-block__title-link"
      }, title), (0, _preact.h)(_IdeationStatus.default, {
        topic: {
          ideaStatus: ideaStatus
        }
      })), (0, _preact.h)("p", {
        className: "thread-list-block__content qa-topic-content"
      }, (0, _preact.h)("span", null, strippedContent))), (0, _preact.h)("div", {
        className: "topic-view_footer bottom_spacing"
      }, (0, _preact.h)(_TopicVoteCount.TopicVoteButton, {
        hasVoted: currentUserVoted,
        className: (0, _classnames.default)({
          add_spacing: true
        }),
        onClick: this.toggleVoteStatus
      }, (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
        count: votes
      }), (0, _preact.h)(_TopicVoteCount.VoteTriangleIcon, null)), (0, _preact.h)(_TopicComments.default, {
        numberOfReplies: replyCount,
        id: id,
        lastPostUrl: lastPostUrl
      }), (0, _preact.h)(_TopicLastPost.default, {
        lastPostAuthor: lastContributorUser,
        lastPostUrl: lastPostUrl,
        lastPostRelativeCreationDate: relativeDate
      })));
    }
  }]);
  return IdeaView;
}(_preact.Component);

var _default = IdeaView;
exports.default = _default;